export const isQuextAdmin = profile => profile.role === 'SUPER_ADMIN';

export const isCustomerAdmin = profile => profile.role === 'CUSTOMER_ADMIN';

export const hasAccessTo = appCode => user => user?.appCodes?.includes(appCode);
